/**
 * @generated SignedSource<<0df062f3cf6ca03f17a997921acea084>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppOrganizationSlugDestinationInputTransferMutation$variables = {
  appId: string;
  organizationId: string;
};
export type AppOrganizationSlugDestinationInputTransferMutation$data = {
  readonly requestAppTransferToOrganization: {
    readonly transferRequestDestination: {
      readonly imageUrl?: string | null | undefined;
      readonly name?: string;
    } | null | undefined;
  };
};
export type AppOrganizationSlugDestinationInputTransferMutation = {
  response: AppOrganizationSlugDestinationInputTransferMutation$data;
  variables: AppOrganizationSlugDestinationInputTransferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appId",
    "variableName": "appId"
  },
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppOrganizationSlugDestinationInputTransferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "requestAppTransferToOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppOrganizationSlugDestinationInputTransferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "requestAppTransferToOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "00e0ce8610612e62a22ef896c56e8bbe",
    "id": null,
    "metadata": {},
    "name": "AppOrganizationSlugDestinationInputTransferMutation",
    "operationKind": "mutation",
    "text": "mutation AppOrganizationSlugDestinationInputTransferMutation(\n  $appId: ID!\n  $organizationId: ID!\n) {\n  requestAppTransferToOrganization(appId: $appId, organizationId: $organizationId) {\n    transferRequestDestination {\n      __typename\n      ... on Organization {\n        name\n        imageUrl\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cdf75f3dfd613323522cf9bb2aac398d";

export default node;
